export const getCSRFToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute("content") || ""
}

export const apiFetch = async <T>(
  url: string,
  options: RequestInit = {},
): Promise<T> => {
  const defaultHeaders = {
    Accept: "application/json",
    "X-CSRF-Token": getCSRFToken(),
    ...(options.method !== "GET" && {
      "Content-Type": "application/json",
    }),
  }

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: "include",
  }

  const response = await fetch(url, config)

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(
      errorData.message || `API request failed: ${response.status}`,
    )
  }

  return await response.json()
}
